import { FC, ReactNode } from 'react';
import { animated, useSpring } from '@react-spring/web';
import { Icon, IconButton } from '@kontentino/ui';
import { faClose } from '@fortawesome/pro-regular-svg-icons/faClose';

type Props = {
  isActive: boolean;
  onHide: () => void;
  children: ReactNode | ReactNode[];
};

const Popup: FC<Props> = ({ isActive, onHide, children }) => {
  const styles = useSpring({
    config: { tension: 200 },
    opacity: isActive ? 1 : 0,
    transform: `translateY(${isActive ? 0 : 100}%)`,
  });

  return (
    <animated.div
      className="tw-absolute tw-bottom-0 tw-right-0 tw-z-[1] tw-flex tw-w-full tw-max-w-[576px] tw-flex-col tw-gap-2 tw-rounded tw-bg-white tw-p-6 tw-shadow-3xl tw-shadow-grayscale-100"
      style={styles}
      data-cy="post-modal_send-for-approval-popup"
    >
      <div className="tw-flex tw-justify-end">
        <IconButton
          variant="secondary"
          onClick={onHide}
          size="small"
          icon={<Icon icon={faClose} />}
        />
      </div>
      {children}
    </animated.div>
  );
};

export default Popup;
